export const documenter = () => {
    let functions = {};
    let tags = {};
    return (name, params, description, outlets, options={}) => {
        if (name === undefined) {
            return Object.keys(functions);
        }
        // quick ooption for getting taggs
        if (name === 1) {
            return tags;
        }

        let names =  [name];
        if (options.altName) {
            names.push(options.altName);
        }
        for (let name of names) {
            if (name in functions) {
                return functions[name];
            }
            if (options.tags) {
                if (Array.isArray(options.tags)) {
                    options.tags.forEach(
                        tag => {
                            if (!tags[tag]) {
                                tags[tag] = [];
                            }
                            tags[tag].push(name);
                        });
                } else {
                    if (!tags[options.tags]) {
                        tags[options.tags] = [];
                    }
                    tags[options.tags].push(name);
                }
            }
            functions[name] = {
                params,
                description,
                outlets,
                ...options
            };
        }
    };
};

